module.exports = __webpack_public_path__ + "img/中文版_库尔_四川.44932666.webp";